import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.css';


// Custom dropdown component
// Handles opening/closing, selecting an option, and detecting clicks outside to close
// Uses props for options, placeholder text, default value, and selection callback
const Dropdown = ({ options, placeholder, def, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(def);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleOptionClick = (option) => {
    setSelected(option);
    onSelect(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <div className={`dropdown__header ${isOpen ? 'open' : ''}`} onClick={toggleDropdown}>
        {selected ? selected.label : (def ? def.label : placeholder)}
        <span className={`dropdown__arrow ${isOpen ? 'open' : ''}`}>&#9662;</span>
      </div>
      {isOpen && (
        <div className="dropdown__menu">
          {options.map((option) => (
            <div
              key={option.value}
              className="dropdown__item"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
